<template>
  <div id="">
    <template v-for="group  in order.root" >
      <div class="container-fluid px-0">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <h4>{{group}}</h4>
        </nav>

        <template v-for="team in order[group]">
          <nav class="navbar navbar-dark bg-info">
            <h4>{{team}}</h4>
          </nav>
          <div class="container">

          <div class="row">
            <template v-for=" member in members[group][team]">

              <Member  v-if="member.signup == (type == 1) " :member="member"></Member>
            </template>
          </div>
        </div>

        </template>
        <div id="">

        </div>
      </div>

      </template>
  </div>
</template>
<script>
import Member from '@/components/Member'

export default {
  name: "",
  props: ['members',"type","order"],
  data: () => ({

  }),
  components: {
    Member
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/MemberList.vue